<template>
  <div class="monit-page">
    <div :class="`monit-main column`" :style="layoutLoading">
      <h4 v-if="mobile" class="page-title col-xs-12 pt-1">Estação</h4>
      <div v-if="loading" class="col-xs-12 center-xs mt-2">
        <spinner /> Buscando estação...
      </div>

      <div class="col-xs-12 pt-xl-2" v-show="!loading">
        <div class="container-card">
          <div class="title-card">
            <settings-outline-icon title="configuração" />
            <span>Configuração da estação</span>
          </div>
          <div class="col-xs-12 config-details">
            <div class="group-info">
              <span class="title">Latitude:</span>
              <span>
                {{
                  station && station.LATITUDE
                    ? station.LATITUDE.toFixed(5)
                    : "Não há dado configurado."
                }}
              </span>
            </div>

            <div class="group-info">
              <span class="title">Longitude:</span>
              <span>
                {{
                  station && station.LONGITUDE
                    ? station.LONGITUDE.toFixed(5)
                    : "Não há dado configurado."
                }}
              </span>
            </div>

            <div class="group-info">
              <span class="title">Altitude:</span>
              <span>
                {{
                  station && station.ALTITUDE
                    ? station.ALTITUDE.toFixed(2) + " m"
                    : "Não há dado configurado."
                }}
              </span>
            </div>
            <div class="group-info">
              <span class="title">Altura do anemômetro:</span>
              <span>
                {{
                  station && station.H_ANEMOMETRO
                    ? station.H_ANEMOMETRO.toFixed(2) + " m"
                    : "Não há dado configurado."
                }}
              </span>
            </div>
          </div>
        </div>

        <div class="container-card mt-2">
          <div class="title-card mt-2">Relatórios</div>
          <div class="row">
            <div class="col-xs-12 col-xl-6 col-sm-6">
              <b-button
                v-if="!!sensorId"
                size="sm"
                :class="`p-2 mb-1`"
                variant="3v3"
                @click="showPureForm('EXPORTAR DADOS BRUTOS')"
                block
              >
                EXPORTAR DADOS BRUTOS
              </b-button>

              <div v-else>
                <b-button
                  v-b-toggle="'collapse-1'"
                  class="mb-1 p-2 w-100"
                  variant="outline-primary"
                >
                  Por que não consigo acessar os dados brutos?
                </b-button>
                <b-collapse id="collapse-1" class="mb-1">
                  <b-card
                    >É necessário ter um sensor EMR atrelado ao dispositivo de
                    estação.</b-card
                  >
                </b-collapse>
                <!-- <b-link>Por que não consigo acessar os dados brutos?</b-link> -->
              </div>
            </div>
            <div class="col-xs-12 col-xl-6 col-sm-6">
              <b-button
                v-if="!disableETZeroReport"
                size="sm"
                class="p-2"
                variant="3v3"
                @click="showET0Form('EXPORTAR ET0')"
                block
              >
                EXPORTAR ET0
              </b-button>

              <div v-else>
                <b-button
                  v-b-toggle="'collapse-2'"
                  size="sm"
                  class="mb-1 p-2 w-100"
                  variant="outline-primary"
                  @click="
                    showForm = false;
                    showET0Errors = !showET0Errors;
                  "
                >
                  Por que não consigo calcular ET0?
                </b-button>
                <b-collapse id="collapse-2">
                  <b-card>
                    <div v-if="showET0Errors">
                      Para calcular a ET0, você precisa:
                      <ul>
                        <li v-for="(err, index) in reportErrs" :key="index">
                          {{ err }}
                        </li>
                      </ul>
                    </div>
                  </b-card>
                </b-collapse>
              </div>
            </div>

            <b-card class="w-100 m-2" v-show="showForm">
              <h6 v-text="titleDropdown"></h6>

              <b-form
                v-show="showForm"
                novalidate
                @keyup.enter="downloadReport"
              >
                <b-form-text id="stationStart"> Início* </b-form-text>
                <b-form-input
                  v-model="date.START_DATE"
                  aria-describedby="stationStart"
                  id="stationStart"
                  type="date"
                  :state="startState"
                />
                <b-form-text id="stationEnd"> Fim* </b-form-text>
                <b-form-input
                  v-model="date.END_DATE"
                  aria-describedby="stationEnd"
                  id="stationEnd"
                  type="date"
                  :state="endState"
                />
                <b-form-text id="stationTime" v-if="date.type == 'et0'">
                  Hora*
                </b-form-text>
                <b-form-select
                  v-if="date.type == 'et0'"
                  v-model="date.TIME"
                  aria-describedby="stationTime"
                  id="stationTime"
                  :options="hours"
                />

                <div class="row" v-if="date.type == 'et0'">
                  <div class="col-xs-6">
                    <b-form-text id="measures"> Mostrar </b-form-text>
                    <b-form-select
                      v-model="organizeET0.measures"
                      aria-describedby="stationTime"
                      id="stationTime"
                      :options="[
                        {
                          value: 2,
                          text: 'Máx e mín',
                        },
                        {
                          value: 1,
                          text: 'Média',
                        },
                      ]"
                    />
                  </div>
                  <div class="col-xs-6">
                    <b-form-text id="stationEnd"> Radiação em </b-form-text>
                    <b-form-select
                      v-model="organizeET0.rad"
                      aria-describedby="stationTime"
                      id="stationTime"
                      :options="['kJ/m²', 'w/m²']"
                    />
                  </div>
                </div>

                <br />

                <b-btn
                  ref="btnStationReport"
                  @click="downloadReport('pdf')"
                  variant="secondary"
                  block
                >
                  <report-icon
                    class="mr-1"
                    style="font-size: 1em; vertical-align: -3%"
                    title=""
                  />Gerar relatório (PDF)
                </b-btn>

                <b-btn
                  ref="btnStationReport"
                  @click="downloadReport('xlsx')"
                  variant="secondary"
                  block
                >
                  <report-icon
                    class="mr-1"
                    style="font-size: 1em; vertical-align: -3%"
                    title=""
                  />Gerar relatório (XLSX)
                </b-btn>

                <b-btn
                  ref="btnStationReport"
                  @click="downloadReport('csv')"
                  variant="secondary"
                  block
                >
                  <report-icon
                    class="mr-1"
                    style="font-size: 1em; vertical-align: -3%"
                    title=""
                  />Gerar relatório (CSV)
                </b-btn>
              </b-form>
            </b-card>
          </div>
          <Tabulator
            v-if="createTabulator"
            :data="tableData"
            :columns="tableColumns"
            :type="typeTable"
            :local="getLocal"
            @clean="CleanTabulator"
          />
        </div>
      </div>
      <div
        class="col-xs-12 content chart mt-2 container-card m-2"
        v-show="!loading && sensorsDetails.length"
      >
        <div v-if="sensorsDetails.length" class="title-card">
          Gráficos de estação
        </div>
        <div class="row center-xs" v-if="sensorsDetails.length">
          <div class="col-xs-12">
            <chart-station
              :items="sensorsDetails"
              :altitude="station.ALTITUDE"
              :anemometer-height="station.H_ANEMOMETRO"
              :longitude="station.LONGITUDE"
              :latitude="station.LATITUDE"
              :utc="utc"
              :name-station="`Estação ${station.ADDR}`"
            />
          </div>
        </div>
      </div>
    </div>

    <dirs-details
      v-if="!mobile && !showSensorDetails && !showStationDetails && !loading"
      :item="dir"
      :status-color="dirVariant"
      :variant="dirVariant"
      :updated="dirUpdated"
      :show-details="showDirDetails"
      :visible-close="false"
      data-station="disableBottom"
      :success-percentage="
        Object.keys(dir).length &&
        dir.RF &&
        calculatePercentage(dir.RF.ack[0], dir.RF.ack[1])
      "
      @close-details="showDirDetails = false"
    />
    <b-modal
      ref="formError"
      no-close-on-backdrop
      centered
      hide-header
      hide-footer
      size="sm"
      body-bg-variant="warning"
    >
      <h5>Atenção!</h5>
      <div class="row">
        <div class="col-xs-12">
          Não é possível realizar a busca de dados porque
        </div>
        <div class="col-xs-3 center-xs">
          <alert-icon title="" style="font-size: 3em" />
        </div>
        <ul class="col-xs-9">
          <li v-for="err in errors" :key="err">{{ err }}</li>
        </ul>
      </div>
      <b-btn
        v-if="$refs.formError"
        block
        variant="light"
        size="sm"
        @click="$refs.formError.hide"
        >Vou corrigir</b-btn
      >
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Tabulator from "./components/Tabulator";
// import { ExcelFormatter } from "xlsx-generator";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { updateFormatter, organizer } from "@/pages/components/helpers";
import { monit, stations } from "@/api";
export default {
  name: "station",
  components: {
    Tabulator,
  },
  created() {
    this.controller = new AbortController();
    this.$emit("title-change", "Estação");
    monit
      .station(this.controller)
      .then((ret) => {
        this.loading = false;
        if (ret.status) {
          this.showDirDetails = true;
          this.station = ret.value[0];
          if (this.$route.params.id == "EMR") this.selected = ret.value[0];
          this.sensorId = this.station.EMR;
          this.monitLoop();
        } else {
          this.station = { ID: null };
          alert(ret.log, ret.alert);
        }
        return monit.windrose(this.controller);
      })
      .then((ret) => {
        if (!this.sensorId) {
          this.reportErrs.push(
            "Ter um sensor de estação atribuído ao dispositivo."
          );
        }
        if (this.station && Object.keys(this.station).length) {
          if (!this.station.LATITUDE || !this.station.LONGITUDE)
            this.reportErrs.push(
              "Que a estação tenha coordenadas configuradas."
            );
          if (!this.station.ALTITUDE)
            this.reportErrs.push("Que a altitude esteja configurada.");
          if (!this.station.H_ANEMOMETRO)
            this.reportErrs.push("Configurar a altura do anemômetro.");
          this.disableETZeroReport = !!this.reportErrs.length;
        } else this.disableETZeroReport = true;
        this.windPoints = ret;
      })
      .catch((err) => {
        console.error(err);
      });
  },
  props: {
    local: [String],
    utc: [String, Number],
    mobile: Boolean,
  },
  data() {
    return {
      showForm: false,
      loading: true,
      loadingCharts: false,
      showDirDetails: false,
      showSensorDetails: false,
      showStationDetails: false,
      active: "info",
      windPoints: {},
      dir: {},
      selected: {},
      timeout: null,
      controller: null,
      // dirController: null,
      // sensorController: null,
      type: "station",
      disableETZeroReport: false,
      reportErrs: [],
      errors: [],
      station: null,
      stationRF: null,
      sensorId: 0,
      sensors: [],
      measuresPositions: [],
      sensorsDetails: [],
      sensorsDetailsFlag: false,
      stationParameters: {},
      thHeaders: [
        "TEMPERATURA (°C)",
        "UMIDADE (%)",
        "PTO. ORVALHO (°C)",
        "PRESSÃO (hPa)",
        "VENTO (m/s)",
        "RADIAÇÃO",
        "CHUVA",
      ],
      daysToTable: [],
      hours: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],
      date: {
        START_DATE: "",
        END_DATE: "",
        TIME: "00",
        type: "",
      },
      organizeET0: {
        measures: 2, //por padrão mostra-se máx e mín
        rad: "kJ/m²",
      },
      showET0Errors: false,
      dirDetailsWidth: 0,
      tableData: [],
      tableColumns: [],
      createTabulator: false,
      typeTable: "",
      titleDropdown: "",
    };
  },
  watch: {
    showStationDetails(newValue, oldValue) {
      if (!newValue && oldValue) this.active = "info";
    },
    selected(newValue, oldValue) {
      if (Object.keys(newValue).length && newValue.ID != oldValue.ID)
        this.active = "info";
    },
    $route(newRoute) {
      if (newRoute.params.id) {
        this.selected =
          newRoute.params.id == "EMR"
            ? this.station
            : this.sensors.filter((e) => e.NAME == newRoute.params.id)[0];
      } else this.selected = {};
    },
    mobile() {
      this.showDetailsStation(this.active);
    },
    active(newValue, oldValue) {
      this.showDetailsStation(this.active);
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.controller ? this.controller.abort() : null;
    // this.dirController ? this.dirController.abort() : null;
    // this.sensorController ? this.sensorController.abort() : null;
  },
  computed: {
    getLocal() {
      let info = this.local;
      return info == ""
        ? "-"
        : info
            .toLowerCase()
            .split(" ")
            .map((word) => word[0].toUpperCase() + word.substr(1))
            .join(" ");
    },
    layoutLoading() {
      if (this.loading) {
        return ` width: calc(100%);
          transition: 0.1s;
          overflow-y: auto;
          height: 100%;`;
      } else if (this.sensorsDetails.length) {
        return `
          width: calc(100% - 361px);
          transition: 0.1s;
          overflow-y: auto;
          height: 100%;
      `;
      } else {
        return ` width: calc(100%);
          transition: 0.1s;
          overflow-y: auto;
          height: 100%;`;
      }
    },
    startState() {
      if (this.date.START_DATE) {
        return (
          this.convertDateStringToDate(this.date.START_DATE).getFullYear() >
          2000
        );
      }
      return !!this.date.START_DATE;
    },
    endState() {
      if (this.date.END_DATE) {
        return (
          this.convertDateStringToDate(this.date.END_DATE).getFullYear() > 2000
        );
      }
      return !!this.date.END_DATE;
    },
    InvalidDateDifference() {
      if (
        this.calculateDateDifference(this.date.START_DATE, this.date.END_DATE) >
        31
      )
        return true;
    },
    updated() {
      return Object.keys(this.selected).length && this.selected.TIME
        ? this.formatUpdate(this.selected.TIME)
        : "";
    },
    variant() {
      return Object.keys(this.selected).length
        ? this.setBG(this.selected.STATUS).split("-")[1]
        : "bg-grey";
    },
    dirUpdated() {
      return Object.keys(this.dir).length && this.dir.UPDATE
        ? this.formatUpdate(this.dir.UPDATE)
        : "";
    },
    dirVariant() {
      return Object.keys(this.dir).length
        ? this.BGRF(this.dir.RF && this.dir.RF.stat).split("-")[1]
        : "bg-grey";
    },
  },
  methods: {
    calculateDateDifference(startDateString, endDateString, separator = "-") {
      const startDate = this.convertDateStringToDate(
        startDateString,
        separator
      );
      const endDate = this.convertDateStringToDate(endDateString, separator);
      const differenceInMilliseconds = endDate - startDate;
      const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
      return differenceInDays;
    },

    convertDateStringToDate(dateString, separator = "-") {
      const [year, month, day] = dateString.split(separator);
      return new Date(year, month - 1, day);
    },
    showDetailsStation(active) {
      let details = document.getElementById("details");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      if (active == "info") {
        this.showIo = "";
        let width = "320px";
        if (details && header && footer) {
          details.style.width = width;
          header.style.width = width;
          footer.style.width = width;
        }
        return;
      } else if (active == "charts") {
        let width = this.mobile ? "100%" : "calc(100% - 51px)";
        if (details && header && footer) {
          details.style.width = width;
          header.style.width = width;
          footer.style.width = width;
          return;
        }
      }
    },
    selectDetails(idx) {
      let tabs = ["info", "charts"];
      this.active = tabs[idx];
    },
    monitLoop() {
      // this.dirController = new AbortController();
      monit
        // .dir(this.dirController)
        .dir(this.controller)
        .then((res) => {
          return res.json();
        })
        .then((ret) => {
          if (ret.length && this.showDirDetails) {
            this.dir = ret.filter((e) => {
              return e.ID == this.station.ADDR;
            })[0];
          }
          // this.sensorController = new AbortController();
        })
        .then((_) =>
          // !this.sensorsDetailsFlag ? monit.sensor(this.sensorController) : false
          !this.sensorsDetailsFlag ? monit.sensor(this.controller) : false
        )
        .then((res) => {
          if (res) {
            this.backendNow = Date.parse(res.headers.get("date"));
            return res.json();
          } else return;
        })
        .then((ret) => {
          let list =
            ret && ret.length
              ? ret.filter((e) => e.ID_S == `${this.sensorId}_sns`)
              : [];
          if (list.length) {
            list = list.filter((e) => !!e);
            if (list.length && !this.sensorsDetailsFlag) {
              this.sensorsDetails = list;
              this.sensorsDetailsFlag = true;
            }
          }
          // this.sensors = list;
        })
        .catch((e) => console.error(e))
        .then((_) => {
          this.timeout = setTimeout(this.monitLoop, 2000);
        });
    },
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    formatUpdate(update) {
      return updateFormatter(update);
    },
    setBG(status) {
      switch (status) {
        case "low":
          return "bg-red";
        case "multi":
          return "bg-orange";
        case "high":
          return "bg-yellow";
        case "ok":
          return "bg-3v3";
        default:
          return "bg-grey";
      }
    },
    BGRF(stat) {
      switch (stat) {
        case 0:
          return "bg-3v3";
        case 7:
          return "bg-yellow";
        case 8:
          return "bg-red";
        case 9:
          return "bg-black";
        default:
          return "bg-grey";
      }
    },
    openSensorDetails(item) {
      this.selected = item;
      this.showSensorDetails = true;
    },
    resetForm() {
      this.date = {
        START_DATE: "",
        END_DATE: "",
        TIME: "00",
      };
      this.organizeET0 = {
        measures: 2, //por padrão mostra-se máx e mín
        rad: "kJ/m²",
      };
    },
    showPureForm(txt) {
      this.titleDropdown = txt;
      this.resetForm();
      this.showET0Errors = false;
      this.date.type = "pure";
      this.showForm = true;
      this.$refs.btnStationReport.focus();
    },
    showET0Form(txt) {
      this.titleDropdown = txt;
      this.resetForm();
      this.date.type = "et0";
      // this.Kc = null;
      this.showForm = true;
      this.$refs.btnStationReport.focus();
    },
    makeDaysArray(start, end) {
      let date = moment(start).format("YYYY-MM-DD");
      end = moment(end).format("YYYY-MM-DD");
      let arr = [];
      for (
        date;
        date <= end;
        date = moment(date).add(1, "days").format("YYYY-MM-DD")
      ) {
        arr.push(date);
      }
      return arr;
    },
    filterMeasurePerPosition(list) {
      return new Promise((resolve, reject) => {
        let result = {};
        this.measuresPositions.map(
          (pos) => (result[pos] = list.filter((e) => e.POS == pos))
        );
        resolve(result);
      });
    },
    filterPerMeasureType(list, isET0) {
      return new Promise((resolve, reject) => {
        this.measuresPositions.map((pos) => {
          if (list[pos].length) {
            let typeKeys = list[pos]
              .map((sensor) => sensor.TYPE.split(" ").join(""))
              .filter((type, i, arr) => arr.indexOf(type) == i);
            let aux = {};
            typeKeys.map((key, i) => {
              aux[key] = list[pos].filter(
                (sensor) => sensor.TYPE.split(" ").join("") == key
              );
              if (!isET0 && !i) aux["TYPE"] = aux[key][0]["TYPE"];
            });
            list[pos] = aux;
          } else {
            list[pos] = {};
          }
        });
        resolve(list);
      });
    },
    filterPerDate(list) {
      return new Promise((resolve, reject) => {
        let stationParameters = {
          TEMPERATURADOAR: {},
          PRESSÃOATMOSFÉRICA: {},
          ALTURAPLUVIOMÉTRICA: {},
          RADIAÇÃOSOLAR: {},
          UMIDADERELATIVADOAR: {},
          DIREÇÃODOVENTO: {},
          VELOCIDADEDOVENTO: {},
        };
        this.measuresPositions.map((pos) => {
          if (Object.keys(list[pos]).length) {
            for (let param of Object.keys(list[pos])) {
              this.daysToOrganize.map((day) => {
                stationParameters[param][day] = list[pos][param].filter(
                  (e) => e.TIME.indexOf(day) > -1
                );
              });
            }
          }
        });
        resolve(stationParameters);
      });
    },
    filterPerHour(list) {
      return new Promise((resolve, reject) => {
        let stationParameters = {
          TEMPERATURADOAR: {},
          PRESSÃOATMOSFÉRICA: {},
          ALTURAPLUVIOMÉTRICA: {},
          RADIAÇÃOSOLAR: {},
          UMIDADERELATIVADOAR: {},
          DIREÇÃODOVENTO: {},
          VELOCIDADEDOVENTO: {},
        };
        for (let param of Object.keys(stationParameters)) {
          this.daysToOrganize.map((day) => {
            stationParameters[param][day] = {};
            this.hours.map((h) => {
              stationParameters[param][day][h] = [];
              if (Object.keys(list[param]).length) {
                if (list[param].hasOwnProperty(day) && list[param][day].length)
                  stationParameters[param][day][h] = list[param][day].filter(
                    (e) => e.TIME.indexOf(day + " " + h) > -1
                  );
              }
            });
          });
        }
        // }
        resolve(stationParameters);
      });
    },
    sortKeys(arr) {
      return arr.sort((a, b) => {
        let x = a.toLowerCase();
        let y = b.toLowerCase();
        if (x < y) return -1;
        else if (x > y) return 1;
        else return 0;
      });
    },
    checkType(type) {
      switch (type) {
        case "PRESSÃO ATMOSFÉRICA":
          return type + " (hPa)";
        case "TEMPERATURA DO AR":
          return type + " (°C)";
        case "UMIDADE RELATIVA DO AR":
          return type + " (%rH)";
        case "VELOCIDADE DO VENTO":
          return type + " (m/s)";
        case "DIREÇÃO DO VENTO":
          return type + " (º)";
        case "PLUVIOMETRIA":
          return type + " (mm)";
        // case 'ALTURA PLUVIOMÉTRICA':
        //   return ''
        case "RADIAÇÃO SOLAR":
          return type + " (w/m²)";
      }
    },
    organizeDataToPDF(data) {
      let layout = "lightHorizontalLines";
      let body = [];
      let header = [{ text: "DATA", style: "tableHeader" }];
      Object.keys(data).map((pos) => {
        header.push({
          text:
            data[pos]["TYPE"] === "ALTURA PLUVIOMÉTRICA"
              ? this.checkType("PLUVIOMETRIA")
              : this.checkType(data[pos]["TYPE"]),
          style: "tableHeader",
        });
      });
      body.push(header);
      organizer(this._manipulatedDate, "TIME")
        .map((e) => e.TIME)
        .filter((e, i, arr) => arr.indexOf(e) === i)
        .map((dt, i) => {
          let fillColor = i % 2 == 0 ? "#ffffff" : "#eef2f5";
          let row = [
            {
              text: dt,
              fillColor,
              style: "datetimeCol",
            },
          ]; //inicializa já com a data hora como primeiro coluna
          this.measuresPositions.map((pos) => {
            this.sortKeys(Object.keys(data[pos])).map((key) => {
              if (key != "TYPE") {
                if (data[pos][key].length) {
                  const filtered = data[pos][key].filter(
                    (e) => e.TIME.indexOf(dt) > -1
                  )[0];

                  const hasValue =
                    typeof filtered === "object" &&
                    Reflect.has(filtered, "VALUE");

                  const hasValidValue = hasValue
                    ? isNaN(filtered.VALUE) === false
                    : false;

                  row.push({
                    text: hasValue && hasValidValue ? filtered.VALUE : "-",
                    fillColor,
                    style: "tableData",
                  });
                } else row.push("-");
              }
            });
          });
          body.push(row);
        });

      return {
        date: moment().format("DD/MM/YYYY"),
        local: this.getLocal,
        content: [
          {
            table: {
              headerRows: 1,
              widths: [95].concat(Array(7).fill("auto")),
              body,
            },
            layout: "headerLineOnly",
          },
        ],
      };
    },
    makeET0TablePdf(data) {
      return new Promise((resolve, reject) => {
        let layout = "lightHorizontalLines";
        let headerRows = 2;
        let body = [];
        if (this.organizeET0.measures == 2) {
          body.push([
            { text: "DATA", style: "tableHeader", rowSpan: 2 },
            { text: "HORA", style: "tableHeader" },
            { text: "TEMPERATURA (°C)", style: "tableHeader", colSpan: 2 },
            {},
            { text: "UMIDADE (%)", style: "tableHeader", colSpan: 2 },
            {},
            { text: "PTO. ORVALHO (°C)", style: "tableHeader", colSpan: 2 },
            {},
            { text: "PRESSÃO (hPa)", style: "tableHeader", colSpan: 2 },
            {},
            { text: "VENTO (m/s)", style: "tableHeader", colSpan: 3 },
            {},
            {},
            { text: "RADIAÇÃO", style: "tableHeader" },
            { text: "CHUVA", style: "tableHeader" },
            { text: "ET0", style: "tableHeader" },
          ]);
          body.push([
            {},
            { text: "GMT " + this.utc, style: "tableSubHeader" },
            { text: "MÁX.", style: "tableSubHeader" },
            { text: "MÍN.", style: "tableSubHeader" },
            { text: "MÁX.", style: "tableSubHeader" },
            { text: "MÍN.", style: "tableSubHeader" },
            { text: "MÁX.", style: "tableSubHeader" },
            { text: "MÍN.", style: "tableSubHeader" },
            { text: "MÁX.", style: "tableSubHeader" },
            { text: "MÍN.", style: "tableSubHeader" },
            { text: "VEL. (méd)", style: "tableSubHeader" },
            { text: "DIR. (méd)", style: "tableSubHeader" },
            // { text: 'DIR.(°)', style: 'tableSubHeader' },
            { text: "RAJ.", style: "tableSubHeader" },
            { text: this.organizeET0.rad, style: "tableSubHeader" },
            { text: "mm", style: "tableSubHeader" },
            { text: "mm", style: "tableSubHeader" },
          ]);
        } else if (this.organizeET0.measures == 1) {
          body.push([
            { text: "DATA", style: "tableHeader", rowSpan: 2 },
            { text: "HORA", style: "tableHeader" },
            { text: "TEMPERATURA (°C)", style: "tableHeader" },
            { text: "UMIDADE (%)", style: "tableHeader" },
            { text: "PTO. ORVALHO (°C)", style: "tableHeader" },
            { text: "PRESSÃO (hPa)", style: "tableHeader" },
            { text: "VENTO (m/s)", style: "tableHeader", colSpan: 3 },
            {},
            {},
            { text: "RADIAÇÃO", style: "tableHeader" },
            { text: "CHUVA", style: "tableHeader" },
            { text: "ET0", style: "tableHeader" },
          ]);
          body.push([
            {},
            { text: "GMT " + this.utc, style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "MÉD.", style: "tableSubHeader" },
            { text: "VEL. (méd)", style: "tableSubHeader" },
            { text: "DIR. (méd)", style: "tableSubHeader" },
            // { text: 'DIR.(°)', style: 'tableSubHeader' },
            { text: "RAJ.", style: "tableSubHeader" },
            { text: this.organizeET0.rad, style: "tableSubHeader" },
            { text: "mm", style: "tableSubHeader" },
            { text: "mm", style: "tableSubHeader" },
          ]);
        }
        for (let d in this.daysToTable) {
          for (let h in this.hours) {
            let dateTime = `${this.daysToTable[d]} ${this.hours[h]}`;
            let afterStart =
              dateTime >= [this.date.START_DATE, this.date.TIME].join(" ");
            let beforeEnd =
              dateTime <=
              moment([this.date.END_DATE, this.TIME].join(" ")).format(
                "YYYY-MM-DD HH:mm"
              );
            if (afterStart && beforeEnd) {
              let row = [];
              let fillColor = h % 2 == 0 ? "#ffffff" : "#eef2f5";
              /* data & hora */
              row.push(
                {
                  text: this.daysToTable[d],
                  fillColor,
                  style: "datetimeCol",
                },
                {
                  text: this.hours[h],
                  fillColor,
                  style: "datetimeCol",
                }
              );
              /* cinco medições com parâmetros */
              let aux = this.calcData(data, this.daysToTable[d], this.hours[h]);
              let arr = ["temp", "humid", "dew", "pres"];
              // let tempMaxET0 = aux["temp"]["max"];
              // let tempMinET0 = aux["temp"]["min"];
              // let humidMaxET0 = aux["humid"]["max"];
              // let humidMinET0 = aux["humid"]["min"];
              let arr2 =
                this.organizeET0.measures == 2 ? ["max", "min"] : ["med"];
              for (let i = 0; i < 4; i++) {
                for (let j = 0; j < this.organizeET0.measures; j++) {
                  row.push({
                    text: this.formatReportRow(
                      parseFloat(aux[arr[i]][arr2[j]])
                    ),
                    fillColor,
                    style: "tableData",
                  });
                }
              }
              let wind = ["vel", "dir", "raj"];
              for (let k = 0; k < 3; k++) {
                const windData = aux["wind"][wind[k]];
                row.push({
                  text:
                    wind[k] === "dir"
                      ? windData || "-"
                      : this.formatReportRow(parseFloat(windData)),
                  fillColor,
                  style: "tableData",
                });
              }
              /* radiação & pluviometria */
              const rad = this.calcRad(
                data["RADIAÇÃOSOLAR"],
                this.daysToTable[d],
                this.hours[h]
              );

              row.push({
                text: this.formatReportRow(parseFloat(rad)), //this value will depend on this.organizeET0.rad
                fillColor,
                style: "tableData",
              });
              this.calcPluv(data, this.daysToTable[d], this.hours[h]).then(
                (ret) =>
                  row.push({
                    text: this.formatReportRow(parseFloat(ret)),
                    fillColor,
                    style: "tableData",
                  })
              );
              this.calcET0(
                this.daysToTable[d],
                this.hours[h],
                aux["temp"]["max"],
                aux["temp"]["min"],
                aux["humid"]["max"],
                aux["humid"]["min"],
                aux["wind"]["vel"],
                this.calcRad(
                  data["RADIAÇÃOSOLAR"],
                  this.daysToTable[d],
                  this.hours[h],
                  "kJ/m²"
                ),
                data["PRESSÃOATMOSFÉRICA"]
              ).then((ret) =>
                row.push({
                  text: this.formatReportRow(parseFloat(ret)),
                  fillColor,
                  style: "tableData",
                })
              );
              // debugger
              // row.push({
              //   text: this.calcET0(data, this.days[d], this.hours[h], row).then(ret => ret),
              //   // text: '-',
              //   fillColor,
              //   style: 'tableData'
              // });
              body.push(row);
              /* row se max e min = [
                0: data
                1: hora (GMT -3 -> UCT)
                2: temp max
                3: temp min
                4: humid max
                5: humid min
                6: pto orvalho max
                7: pto orvalho min
                8: pres max (em hPa)
                9: press min (em hPa)
                10: velocidade vento
                11: direção vento
                12: rajada vento
                13: radiação (em this.organizeET0.rad) //valores em this.radForET0
                14: chuva,
                15: ET0
              ]
              row se media = [
                0: data
                1: hora (GMT -3 -> UCT)
                2: temp med
                3: humid med
                4: pto orvalho med
                5: pres med (em hPa)
                6: velocidade vento
                7: direção vento
                8: rajada vento
                9: radiação (em this.organizeET0.rad)
                10: chuva,
                11: ET0
              ] */
            }
          }
        }

        resolve({
          date: moment().format("DD/MM/YYYY"),
          local: this.getLocal,
          content: [
            {
              table: {
                headerRows,
                widths: Array(this.organizeET0.measures == 2 ? 16 : 12).fill(
                  "auto"
                ),
                body,
              },
              layout: "headerLineOnly",
            },
          ],
        });
      });
    },
    createPDF(data, type) {
      try {
        const tableSchema = {
          footer: (currentPage, pageCount) => {
            return {
              columns: [
                {
                  text: "Desenvolvido por 3v3 Tecnologia",
                  margin: [35, 0],
                  alignment: "left",
                  color: "#999",
                },
                {
                  text: `${currentPage} de ${pageCount}`,
                  margin: [40, 0],
                  alignment: "right",
                  color: "#999",
                },
              ],
            };
          },
          header: {
            columns: [
              {
                text: data.local,
                alignment: "left",
                margin: [40, 20],
                color: "#999",
              },
              {
                text: data.date,
                alignment: "right",
                margin: [40, 20],
                color: "#999",
              },
            ],
          },
          content: data.content,
          pageOrientation: "landscape",
          pageMargins: [15, 50, 20, 30],
          styles: {
            tableHeader: {
              fillColor: "#7AB648",
              color: "#fff",
              alignment: "center",
              fontSize: 10,
              bold: true,
            },
            tableSubHeader: {
              fillColor: "#3F4E59",
              alignment: "center",
              color: "#fff",
              fontSize: 9,
              bold: true,
            },
            tableData: {
              fontSize: 10,
              alignment: "center",
            },
            datetimeCol: {
              fontSize: 10,
              alignment: "center",
              bold: true,
            },
          },
        };

        console.log("Download iniciado...");

        pdfMake.createPdf(tableSchema).open({}, window.open("", "_blank"));
      } catch (error) {
        console.error("Falha ao crir pdf :: ", error);
      }
    },
    calcRad(rad, d, h, toET0) {
      let data = rad[d][h];
      let rs;
      if (data.length) {
        if (this.organizeET0.rad == "kJ/m²" || toET0) {
          const seconds_between_reads = 3600 / data.length;
          rs = data.reduce(
            (acc, e) => e.VALUE * seconds_between_reads + acc,
            0
          );
          rs = rs / Math.pow(10, 3); //em kJ
          // rs = rs / Math.pow(10,6); //em MJ
          return rs.toFixed(4);
        } else if (this.organizeET0.rad == "w/m²") {
          rs = this.sumValues(data);
          rs = rs / data.length; //media em w
          // rs = rs / Math.pow(10,6); //em MJ
          return rs.toFixed(4);
        }
      }
      //
      else return "-";
    },
    calcPluv(list, d, h) {
      let TYPE = "ALTURAPLUVIOMÉTRICA";
      let data = list[TYPE][d][h].map((e) => e.VALUE);
      // Necessária análise do primeiro valor da próxima hora se h < 23
      // Necessária análise do primeiro valor da primeira hora do dia seguinte se h = 23
      // Justificativa: As vezes o valor muda numa virada de hora/dia
      return new Promise((resolve, reject) => {
        if (h < 23) {
          //buscar no mesmo dia o primeiro minuto hora seguinte
          let nextHour = this.hours[parseInt(h) + 1];
          // ifs complexos ganham uma identação horrível
          if (
            list[TYPE][d][h].filter(
              (e) => e.TIME.split(" ")[1].indexOf(h + ":55") > -1
            ).length && //se 'd h:55' (os últimos 5 minutos da hora atual) tiver log
            list[TYPE][d][nextHour] &&
            list[TYPE][d][nextHour].length && //se houver log para a próxima hora
            list[TYPE][d][nextHour].filter(
              (e) => e.TIME.split(" ").indexOf(nextHour + ":00") > -1
            ).length //se 'd h+1:00' (o primeiro minuto da hora seguinte) tiver log
          )
            data.push(
              list[TYPE][d][nextHour].filter(
                (e) => e.TIME.split(" ").indexOf(nextHour + ":00") > -1
              )[0]["VALUE"]
            );
        } else {
          //buscar no dia seguinte o primeiro minuto da primeira hora
          let nextDay = moment(d).add(1, "days").format("YYYY-MM-DD");
          // if (list[TYPE][nextDay] && list[TYPE][nextDay]['00'] && list[TYPE][nextDay]['00'].length) data.push(list[TYPE][nextDay]['00'][0]);
          if (
            list[TYPE][d]["23"] &&
            list[TYPE][d]["23"].length &&
            list[TYPE][d]["23"].filter(
              (e) => e.TIME.split(" ").indexOf("23:55") > -1
            ).length && //se o último minuto da última hora do dia em questão tem log
            list[TYPE][nextDay] &&
            list[TYPE][nextDay]["00"] &&
            list[TYPE][nextDay]["00"].length && //se a primeira hora do dia seguinte tem log
            list[TYPE][nextDay]["00"].filter(
              (
                e //se o primeiro minuto da primeira hora do dia seguinte tem log
              ) => e.TIME.split(" ").indexOf("00:00") > -1
            ).length
          )
            data.push(
              list[TYPE][nextDay]["00"].filter(
                (e) => e.TIME.split(" ").indexOf("00:00") > -1
              )[0]["VALUE"]
            );
        }
        if (data.length) {
          let accumulator = 0;
          let reference = 0;
          let currently = 0;
          data.map((currently, i) => {
            if (currently) {
              let FIRST_NOT_NULL = !accumulator && !reference;
              if (FIRST_NOT_NULL) reference = currently;
              let difference = currently - reference;
              if (difference >= 0) {
                accumulator += difference;
                reference = currently;
              } else {
                if (difference > -reference) {
                  accumulator -= difference;
                  reference = currently;
                }
              }
            }
          });
          resolve(accumulator.toFixed(1));
        } else resolve("-");
      });
      // return data.length ? (data.reduce((acc, e, i, data) => acc + e)).toFixed(2) : '-';
    },
    calcET0(
      d,
      h,
      tempMax,
      tempMin,
      humidMax,
      humidMin,
      windVel,
      rad,
      presData
    ) {
      return new Promise((resolve, reject) => {
        /* Data: dia e mês
        Hora local da análise (00:00 ~ 23:59)
        Latitude local em graus (Lat)
        Longitude local em graus (Lm)
        Longitude média da zona horária (UCT - Tempo Universal Coordenado) em graus (Lz)
        Altitude local em metros (z)
        Altitude do anemômetro em metros (z1) */
        presData = presData[d][h];
        const stationParameters = {
          z: this.station.ALTITUDE
            ? this.station.ALTITUDE
            : ((_) => {
                alert(
                  "Falta parâmetro(s) de estação para cálculo de ET0: resultado alterado. Verifique LATITUDE e LONGITUDE do dispositivo EMR, UTC do sistema, ALTITUDE e ALTURA DO ANEMÔMETRO.",
                  "e"
                );
                return null;
              })(),
          z1: this.station.H_ANEMOMETRO
            ? this.station.H_ANEMOMETRO
            : ((_) => {
                alert(
                  "Falta parâmetro(s) de estação para cálculo de ET0: resultado alterado. Verifique LATITUDE e LONGITUDE do dispositivo EMR, UTC do sistema, ALTITUDE e ALTURA DO ANEMÔMETRO.",
                  "e"
                );
                return null;
              })(),
          Thr:
            tempMax != "-" && tempMin != "-"
              ? (parseFloat(tempMax) + parseFloat(tempMin)) / 2
              : null,
          URhr:
            humidMax != "-" && humidMin != "-"
              ? (parseFloat(humidMax) + parseFloat(humidMin)) / 2
              : null,
          Phr: presData.length
            ? presData.reduce((acc, e, i, arr) => acc + e.VALUE, 0) /
              presData.length /
              10
            : // (this.sumValues(presData) / presData.length) / 10 :
              null, //convertendo de hPa para kPa
          u2: windVel != "-" ? parseFloat(windVel) : null,
          Rs: rad != "-" ? parseFloat(rad) / Math.pow(10, 3) : null, //convertendo de kJ/m²h para MJ/m²h
        };
        const PI = Math.PI;
        /* PARÂMETROS INDEPENDENTES DE ESTAÇÃO
          Gsc = Constante solar
          delta = Declinação solar em radianos
          Dr = Distâcia inversa relativa entre a Terra e o Sol
          Sc = Parâmetro de correção sazonal do sol em horas
          omega = Ângulo solar no ponto médio do período de análise
          omega1 = Ângulo solar no começo do período de análise
          omega2 = Ângulo solar no fim do período de análise
          omegaS = Ângulo de por do sol
          Ra = Radiação solar no topo da atmosfera
          Rso = Radiação solar incidente na ausência de nuvens */
        /* PARÂMETROS PARA CÁLCULO DA ET0
          eThr = Pressão de vapor de saturação na temperatura
          Ea = Pressão de vapor de saturação atual
          DELTA = Declividade da curva de pressão de vapor com relação à temperatura
          gama = Constante Psicrométrica
          Rns = Saldo de radiação de ondas curtas
          Rnl = Saldo de radiação de ondas longas
          Rn = Saldo de radiação diário
          G = Fluxo de calor do solo */
        const Gsc = 0.082; //MJ/m²/min
        const dayOfYear = moment(d).dayOfYear();
        const localLat = this.station.LATITUDE * (PI / 180); //convertido para radianos
        const delta = 0.409 * Math.sin((2 * PI * dayOfYear) / 365 - 1.39);
        const Dr = 1 + 0.033 * Math.cos((2 * PI * dayOfYear) / 365);
        const auxSc = (2 * PI * (dayOfYear - 81)) / 364;
        const Sc =
          0.1645 * Math.sin(2 * auxSc) -
          0.1255 * Math.cos(auxSc) -
          0.025 * Math.sin(auxSc);
        const omegaAuxT = parseInt(h) + 0.5;
        let long = Number(this.station.LONGITUDE);
        let omegaAuxLm = long < 0 ? long * -1 : 360 - long;
        const omegaAuxLz = ((utc) => {
          let Lz = 0;
          let deg = utc * -1 * 15;
          Lz = utc < 0 ? deg : 360 - deg;
          return Lz;
        })(Number(this.utc));
        const omega =
          ((omegaAuxLz - omegaAuxLm) * 0.06667 + omegaAuxT + Sc - 12) *
          (PI / 12);
        let Ra;
        let Rso;
        let Rns;
        let kt = 0.95; // índice de turbidez do ar
        let denAuxFirstPart = Math.sin(localLat) * Math.sin(delta);
        let denAuxSecondPart =
          Math.cos(localLat) * Math.cos(delta) * Math.cos(omega);
        let den = denAuxFirstPart + denAuxSecondPart;
        let omegaS = Math.acos(-Math.tan(localLat) * Math.tan(delta));
        if (omega < -omegaS || omega > omegaS) {
          Ra = 0;
        } else {
          // if (stationParameters.Rs > 0) {
          const omega1 = omega - PI / 24;
          const omega2 = omega + PI / 24;
          const RaAuxOmegasDiff = omega2 - omega1;
          const RaAuxFirstPart =
            RaAuxOmegasDiff * Math.sin(localLat) * Math.sin(delta);
          const RaAuxSinDiff = Math.sin(omega2) - Math.sin(omega1);
          const RaAuxSecondPart =
            RaAuxSinDiff * Math.cos(localLat) * Math.cos(delta);
          const RaAuxA = RaAuxFirstPart + RaAuxSecondPart;
          Ra = (12 * 60 * Gsc * Dr * RaAuxA) / PI;
          // Rso = (0.75 + 0.00002 * stationParameters.z) * Ra;
          // } else {
          //   Ra = 0;
          //   Rso = 0;
          // Rns = 0;
        }
        Rso = Ra * Math.exp((-0.0018 * stationParameters.Phr) / (kt * den));
        Rns = (1 - 0.23) * stationParameters.Rs;
        const eThrAux =
          (17.27 * stationParameters.Thr) / (stationParameters.Thr + 237.3);
        const eThr = 0.6108 * Math.exp(eThrAux);
        const Ea = (eThr * stationParameters.URhr) / 100;
        const DELTA =
          (4098 * eThr) /
          ((stationParameters.Thr + 237.3) * (stationParameters.Thr + 237.3));
        const gama = 0.665 * 0.001 * stationParameters.Phr;
        const sigma = 2.043 * Math.pow(10, -10); //em MJ/m²h
        const RnlAuxFirstPart =
          sigma * Math.pow(stationParameters.Thr + 273.16, 4);
        const RnlAuxSecondPart = 0.34 - 0.14 * Math.pow(Ea, 0.5);
        const RnlDivisionAuxThirdPart =
          Rso == 0 ? 0.8 : stationParameters.Rs / Rso; //valor assumido quando Rso = 0 de acordo com exemplo
        const RnlAuxThirdPart = 1.35 * RnlDivisionAuxThirdPart - 0.35;
        const Rnl = RnlAuxFirstPart * RnlAuxSecondPart * RnlAuxThirdPart;
        const Rn = Rns - Rnl;
        const G = omega < -omegaS || omega > omegaS ? 0.5 * Rn : 0.1 * Rn;
        // const G = h > 5 && h < 18 ? 0.5 * Rn : 0.1 * Rn;
        /* Finalmente, o cálculo da ET0 */
        const ET0AuxFirstPartNumerator = 0.408 * (Rn - G);
        const ET0AuxFirstPart =
          (ET0AuxFirstPartNumerator * DELTA) /
          (DELTA + gama * (1 + 0.34 * stationParameters.u2));
        const ET0AuxSecondPartNumerator = 37 / (stationParameters.Thr + 273);
        const ET0AuxSecondPart =
          (ET0AuxSecondPartNumerator *
            stationParameters.u2 *
            (eThr - Ea) *
            gama) /
          (gama * (1 + 0.34 * stationParameters.u2) + DELTA);
        const ET0 = ET0AuxFirstPart + ET0AuxSecondPart;
        if (String(ET0) != "NaN") {
          resolve(ET0 < 0 ? "0.00" : ET0.toFixed(4));
        } else resolve("-");
      });
    },
    calcData(data, d, h) {
      let obj = {
        temp: {},
        humid: {},
        dew: {},
        pres: {},
        wind: {},
      };
      obj.temp = this.calcTempParameters(data, d, h);
      obj.humid = this.calcHumidParameters(data, d, h);
      obj.dew = this.calcDewParameters(data, d, h);
      obj.pres = this.calcPresParameters(data, d, h);
      obj.wind = this.calcWindParameters(data, d, h);
      return obj;
    },
    sumValues(objArray) {
      return objArray.reduce((acc, e) => acc + e.VALUE, 0);
    },
    sumElems(arr) {
      return arr.reduce((acc, value) => acc + value, 0);
    },
    commomCalc(type, list, d, h) {
      let data = list[type][d][h].length
        ? list[type][d][h].map((e) => e.VALUE)
        : [];
      return {
        // inst: data[data.length - 1] != undefined ? data[data.length - 1].toFixed(2) : '-',
        max: data.length ? Math.max(...data).toFixed(4) : "-",
        min: data.length ? Math.min(...data).toFixed(4) : "-",
        med: data.length ? (this.sumElems(data) / data.length).toFixed(4) : "-",
      };
    },
    calcTempParameters(list, d, h) {
      return this.commomCalc("TEMPERATURADOAR", list, d, h);
    },
    calcHumidParameters(list, d, h) {
      return this.commomCalc("UMIDADERELATIVADOAR", list, d, h);
    },
    /* Dew = Orvalho */
    calcDewParameters(list, d, h) {
      let data = list["TEMPERATURADOAR"][d][h].length
        ? list["TEMPERATURADOAR"][d][h].map((e, i) =>
            this.calcTdew(
              e.VALUE ? e.VALUE : null,
              list["UMIDADERELATIVADOAR"][d][h][i]["VALUE"]
                ? list["UMIDADERELATIVADOAR"][d][h][i]["VALUE"]
                : null
            )
          )
        : [];
      return {
        // inst: data[data.length - 1] != undefined || data[data.length - 1] != null ? data[data.length - 1].toFixed(2) : '-',
        max: data.length ? Math.max(...data).toFixed(4) : "-",
        min: data.length ? Math.min(...data).toFixed(4) : "-",
        med: data.length ? (this.sumElems(data) / data.length).toFixed(4) : "-",
      };
    },
    calcTdew(Thr, RH) {
      if (Thr == null || RH == null) return null;
      let e0 = 0.6108 * Math.exp((17.27 * Thr) / (Thr + 237.3));
      let ea = (e0 * RH) / 100;
      let Tdew = (237.3 * Math.log(ea) + 116.91) / (16.78 - Math.log(ea));
      return Tdew;
    },
    calcPresParameters(list, d, h) {
      return this.commomCalc("PRESSÃOATMOSFÉRICA", list, d, h);
    },
    calcWindParameters(list, d, h) {
      let dirData = list["DIREÇÃODOVENTO"][d][h].length
        ? list["DIREÇÃODOVENTO"][d][h].map((e) => e.VALUE)
        : [];

      let velData = list["VELOCIDADEDOVENTO"][d][h].length
        ? list["VELOCIDADEDOVENTO"][d][h].map((e) => {
            return Number(Number(e.VALUE).toFixed(2));
          })
        : [];

      const averageVelocity = this.sumElems(velData) / velData.length;

      const maxVelocity = Math.max(...velData);

      return {
        vel: velData.length
          ? this.correctVelIfNecessary(averageVelocity).toFixed(4)
          : "-",
        dir: dirData.length ? this.occurrence(dirData) : "-",
        raj: velData.length
          ? this.correctVelIfNecessary(maxVelocity).toFixed(4)
          : "-",
      };
    },
    //https://pt.stackoverflow.com/a/99259
    occurrence(list) {
      let directions = Object.keys(this.windPoints);
      let northIdx = directions.indexOf("N");
      let valuesInIndexes = list.map((val) => {
        if (val >= this.windPoints["N"][0] || val < this.windPoints["N"][1])
          return northIdx;
        else {
          for (let idx = 0; idx < directions.length; idx++) {
            let key = directions[idx];
            if (val >= this.windPoints[key][0] && val < this.windPoints[key][1])
              return idx;
          }
        }
      });
      let occurrences = Array(directions.length).fill(0);
      for (let j = 0; j < valuesInIndexes.length; j++) {
        let idx = valuesInIndexes[j];
        occurrences[idx] += 1;
      }
      let appearsMoreIdx = null;
      let currentlyHighestOccurrence = -1;
      for (let k = 0; k < occurrences.length; k++) {
        if (occurrences[k] > currentlyHighestOccurrence) {
          appearsMoreIdx = k;
          currentlyHighestOccurrence = occurrences[k];
        }
      }
      return directions[appearsMoreIdx];
    },
    correctVelIfNecessary(value) {
      const z1 = this.station.H_ANEMOMETRO;

      if (z1 !== null && z1 != 2)
        return (value * 4.87) / Math.log(67.8 * z1 - 5.42);
      else return value;
    },
    downloadReport(type = "pdf") {
      this.errors = [];
      let start = this.date.START_DATE;
      let end = this.date.END_DATE;
      if (!this.startState) this.errors.push("Data inicial vazia ou inválida");
      if (!this.endState) this.errors.push("Data final vazia ou inválida");
      if (this.startState && this.endState) {
        if (start > end)
          this.errors.push("Data inicial não pode ser posterior à data final");
        else if (start == end)
          this.errors.push("Data inicial não pode ser igual à data final");
      }
      if (this.InvalidDateDifference) {
        this.errors.push(
          "A diferença entre as datas de início e fim deve ser de no máximo 31 dias"
        );
      }
      if (this.errors.length) this.$refs.formError.show();
      else {
        switch (this.date.type) {
          case "et0":
            this.searchDataToET0(type);
            break;
          case "pure":
            this.searchPureData(type);
            break;
        }
      }
    },
    CleanTabulator() {
      this.tableData = [];
      this.tableColumns = [];
      this.typeTable = "";
      this.createTabulator = false;
    },
    formatReportRow(value, decimal = 2) {
      if (isNaN(value)) {
        return "-";
      }
      const toFixed = Number(value).toFixed(decimal);
      return Number(toFixed);
    },
    formatPureDataToTabulatorFormat(data, fileFormat) {
      console.log("Gerando relatório... ");

      this.typeTable = fileFormat;
      this.createTabulator = false;
      // let layout = "lightHorizontalLines";
      // let body = [];
      let index = 0;

      const tableColumns = [
        { title: "DATA", field: "DATA" },
        ...this.measuresPositions.map((measurePosition) => {
          const measureName = data[measurePosition]["TYPE"];
          return {
            title: measureName,
            field: measureName,
          };
        }),
      ];

      // No repeated datetimes
      const datetimes = organizer(this._manipulatedDate, "TIME")
        .map((e) => e.TIME)
        .filter((e, i, arr) => arr.indexOf(e) === i);

      const tableRows = datetimes.map((datetime, i) => {
        // let fillColor = i % 2 == 0 ? "#ffffff" : "#eef2f5";
        //inicializa já com a data hora como primeiro coluna
        const dateTimeColumnName = tableColumns[0].field;

        const row = {
          id: index,
          [dateTimeColumnName]: datetime,
        };
        // Object.assign(row, { id: index, [tableColumns[0].field]: datetime });

        this.measuresPositions.forEach((measurePosition) => {
          const measures = data[measurePosition];

          const measuresNames = Object.keys(measures);

          this.sortKeys(measuresNames).map((measureName) => {
            if (measureName != "TYPE") {
              const measureData = data[measurePosition][measureName];

              if (measureData.length) {
                let filtered = measureData.filter(
                  (e) => e.TIME.indexOf(datetime) > -1
                )[0];

                if (filtered) {
                  Object.assign(row, {
                    [tableColumns[
                      tableColumns.findIndex((e) => e.field === filtered.TYPE)
                    ].field]: this.formatReportRow(filtered.VALUE),
                  });
                }
              }
              // else row.push({});
            }
          });
        });

        // datas.push(row);
        index++;
        return row;
      });

      this.tableData = tableRows;
      this.tableColumns = tableColumns;
      this.createTabulator = true;
    },
    organizeTabulatorCSV(data) {
      console.log("Gerando relatório em csv... ");
      this.createTabulator = false;
      return new Promise((resolve, reject) => {
        let layout = "lightHorizontalLines";
        let headerRows = 2;
        let tableColumns = [];
        let body = [];
        let index = 0;
        if (this.organizeET0.measures == 2) {
          tableColumns = [
            //0
            { title: "DATA", field: "DATA" },
            //1
            {
              title: "HORA (GMT) " + this.utc,
              field: "HORA",
            },
            //2
            {
              title: "TEMPERATURA MÁX. (°C) ",
              field: "MAX_TEMP",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //3
            {
              title: "TEMPERATURA MÍN. (°C) ",
              field: "MIN_TEMP",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //4
            {
              title: "UMIDADE MÁX. (%) ",
              field: "MAX_UMID",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //5
            {
              title: "UMIDADE MÍN. (%) ",
              field: "MIN_UMID",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //6
            {
              title: "PTO. ORVALHO MÁX. (°C) ",
              field: "MAX_PTO",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //7
            {
              title: "PTO. ORVALHO MÍN. (°C)",
              field: "MIN_PTO",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //8
            {
              title: "PRESSÃO MÁX. (hPa) ",
              field: "MAXHPA",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //9
            {
              title: "PRESSÃO MÍN. (hPa) ",
              field: "MINHPA",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //10
            {
              title: "VENTO  VEL. (m/s)",
              field: "VELVENTO",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //11
            {
              title: "VENTO DIR.",
              field: "DIRVENTO",
              formatter: (cell) => cell.getValue() || "-",
            },
            //12
            {
              title: "VENTO RAJ. (m/s) ",
              field: "RAJ",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //13
            {
              title: "RADIAÇÃO" + this.organizeET0.rad,
              field: "RADIACAO",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //14
            {
              title: "CHUVA (mm)",
              field: "CHUVA",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
            //15
            {
              title: "ET0 (mm)",
              field: "ET0",
              formatter: (cell) =>
                this.formatReportRow(parseFloat(cell.getValue())),
            },
          ];
        } else if (this.organizeET0.measures == 1) {
          tableColumns = [
            //0
            { title: "DATA", field: "DATA" },
            //1
            {
              title: "HORA (GMT) " + this.utc,
              field: "GMT",
            },
            //2
            {
              title: "TEMPERATURA MÉD. (°C) ",
              field: "MED_temp",
            },
            //3
            {
              title: "UMIDADE MÉD.(%) ",
              field: "MED_umid",
            },
            //4
            {
              title: "PTO. ORVALHO (°C) ",
              field: "MED_pto",
            },
            //5
            {
              title: "PRESSÃO MÉD. (hPa) ",
              field: "MED_hpa",
            },
            //6
            {
              title: "VENTO VEL (m/s) ",
              field: "VELVENTO",
            },
            //7
            {
              title: "VENTO DIR",
              field: "DIRVENTO",
            },
            //8
            {
              title: "VENTO RAJ. (m/s) ",
              field: "RAJ",
            },
            //9
            {
              title: "RADIAÇÃO " + this.organizeET0.rad,
              field: "RADIACAO",
            },
            //10
            { title: "CHUVA (mm)", field: "mm_chuva" },
            //11
            { title: "ET0 (mm)", field: "mm_et0" },
          ];
        }
        for (let d in this.daysToTable) {
          for (let h in this.hours) {
            let dateTime = `${this.daysToTable[d]} ${this.hours[h]}`;
            let afterStart =
              dateTime >= [this.date.START_DATE, this.date.TIME].join(" ");
            let beforeEnd =
              dateTime <=
              moment([this.date.END_DATE, this.date.TIME].join(" ")).format(
                "YYYY-MM-DD HH:mm"
              );
            if (afterStart && beforeEnd) {
              let row = {};
              var copy = {};
              let fillColor = h % 2 == 0 ? "#ffffff" : "#eef2f5";
              Object.assign(row, {
                id: index,
                // DATA
                [tableColumns[0].field]: this.daysToTable[d],
                // HORA
                [tableColumns[1].field]: this.hours[h],
              });

              /* cinco medições com parâmetros */
              let aux = this.calcData(data, this.daysToTable[d], this.hours[h]);
              let arr = ["temp", "humid", "dew", "pres"];
              // let tempMaxET0 = aux["temp"]["max"];
              // let tempMinET0 = aux["temp"]["min"];
              // let humidMaxET0 = aux["humid"]["max"];
              // let humidMinET0 = aux["humid"]["min"];
              // CHECAR SE IRÁ COLOCAR O MÁXIMO OU MÉDIA
              let arr2 =
                this.organizeET0.measures == 2 ? ["max", "min"] : ["med"];
              // SE FOR MAX E MIN
              if (arr2.length == 2) {
                Object.assign(row, {
                  // TEMPERATURA - MAX
                  [tableColumns[2].field]: this.formatReportRow(
                    aux[arr[0]][arr2[0]]
                  ),
                  //TEMPERATURA 0 MIN
                  [tableColumns[3].field]: this.formatReportRow(
                    aux[arr[0]][arr2[1]]
                  ),
                  //HUMIDADE - MAX
                  [tableColumns[4].field]: this.formatReportRow(
                    aux[arr[1]][arr2[0]]
                  ),
                  //HUMIDADE - MIN
                  [tableColumns[5].field]: this.formatReportRow(
                    aux[arr[1]][arr2[1]]
                  ),
                  //DEW - MAX
                  [tableColumns[6].field]: this.formatReportRow(
                    aux[arr[2]][arr2[0]]
                  ),
                  //DEW - MIN
                  [tableColumns[7].field]: this.formatReportRow(
                    aux[arr[2]][arr2[1]]
                  ),
                  //PRESSÃO - MAX
                  [tableColumns[8].field]: this.formatReportRow(
                    aux[arr[3]][arr2[0]]
                  ),
                  //PRESSÃO - MIN
                  [tableColumns[9].field]: this.formatReportRow(
                    aux[arr[3]][arr2[1]]
                  ),
                });

                // VENTO
                let wind = ["vel", "dir", "raj"];
                for (let k = 0; k < 3; k++) {
                  Object.assign(row, {
                    // velocidade
                    [tableColumns[10].field]: this.formatReportRow(
                      aux["wind"][wind[0]]
                    ),
                    //Direção
                    [tableColumns[11].field]: aux["wind"][wind[1]] || "-",
                    //Raj
                    [tableColumns[12].field]: this.formatReportRow(
                      aux["wind"][wind[2]]
                    ),
                  });
                }

                const rad = this.calcRad(
                  data["RADIAÇÃOSOLAR"],
                  this.daysToTable[d],
                  this.hours[h]
                );
                /* RADIAÇÃO */
                Object.assign(row, {
                  [tableColumns[13].field]: this.formatReportRow(rad),
                });

                // PLUVIOMETRIA
                this.calcPluv(data, this.daysToTable[d], this.hours[h]).then(
                  (ret) => {
                    Object.assign(row, {
                      [tableColumns[14].field]: this.formatReportRow(ret),
                    });
                  }
                );

                this.calcET0(
                  this.daysToTable[d],
                  this.hours[h],
                  aux["temp"]["max"],
                  aux["temp"]["min"],
                  aux["humid"]["max"],
                  aux["humid"]["min"],
                  aux["wind"]["vel"],
                  this.calcRad(
                    data["RADIAÇÃOSOLAR"],
                    this.daysToTable[d],
                    this.hours[h],
                    "kJ/m²"
                  ),
                  data["PRESSÃOATMOSFÉRICA"]
                ).then((ret) =>
                  Object.assign(row, {
                    [tableColumns[15].field]: this.formatReportRow(ret),
                  })
                );
              }
              // SE FOR MÉDIA
              else {
                Object.assign(row, {
                  // TEMPERATURA - MÉDIA
                  [tableColumns[2].field]: this.formatReportRow(
                    aux[arr[0]][arr2[0]]
                  ),
                  //HUMIDADE - MÉDIA
                  [tableColumns[3].field]: this.formatReportRow(
                    aux[arr[1]][arr2[0]]
                  ),
                  //DEW - MÉDIA
                  [tableColumns[4].field]: this.formatReportRow(
                    aux[arr[2]][arr2[0]]
                  ),
                  //PRESSÃO - MÉDIA
                  [tableColumns[5].field]: this.formatReportRow(
                    aux[arr[3]][arr2[0]]
                  ),
                });

                // VENTO
                let wind = ["vel", "dir", "raj"];
                for (let k = 0; k < 3; k++) {
                  Object.assign(row, {
                    // velocidade
                    [tableColumns[6].field]: this.formatReportRow(
                      aux["wind"][wind[0]]
                    ),
                    //Direção
                    [tableColumns[7].field]: aux["wind"][wind[1]] || "-",
                    //Raj
                    [tableColumns[8].field]: this.formatReportRow(
                      aux["wind"][wind[2]]
                    ),
                  });
                }
                /* RADIAÇÃO */
                Object.assign(row, {
                  [tableColumns[9].field]: this.formatReportRow(
                    this.calcRad(
                      data["RADIAÇÃOSOLAR"],
                      this.daysToTable[d],
                      this.hours[h]
                    )
                  ),
                });

                // PLUVIOMETRIA
                this.calcPluv(data, this.daysToTable[d], this.hours[h]).then(
                  (ret) => {
                    Object.assign(row, {
                      [tableColumns[10].field]: this.formatReportRow(ret),
                    });
                  }
                );

                this.calcET0(
                  this.daysToTable[d],
                  this.hours[h],
                  aux["temp"]["max"],
                  aux["temp"]["min"],
                  aux["humid"]["max"],
                  aux["humid"]["min"],
                  aux["wind"]["vel"],
                  this.calcRad(
                    data["RADIAÇÃOSOLAR"],
                    this.daysToTable[d],
                    this.hours[h],
                    "kJ/m²"
                  ),
                  data["PRESSÃOATMOSFÉRICA"]
                ).then((ret) =>
                  Object.assign(row, {
                    [tableColumns[11].field]: this.formatReportRow(ret),
                  })
                );
              }

              body.push(row);
            }
            index++;
          }
        }
        resolve([body, tableColumns]);
      });
    },
    organizeTabulator(data) {
      console.log("Gerando relatório... ");
      this.createTabulator = false;
      return new Promise((resolve, reject) => {
        let tableColumns = [];
        let body = [];
        let index = 0;
        if (this.organizeET0.measures == 2) {
          tableColumns = [
            { title: "DATA", field: "DATA", download: true },
            {
              title: "HORA",
              download: true,
              columns: [
                { title: "GMT " + this.utc, field: "HORA", download: true },
              ],
            },
            {
              title: "TEMPERATURA (°C)",
              download: true,
              columns: [
                { title: "MÁX.", field: "MAX_TEMP", download: true },
                { title: "MÍN.", field: "MIN_TEMP", download: true },
              ],
            },
            {
              title: "UMIDADE (%)",
              download: true,
              columns: [
                { title: "MÁX.", field: "MAX_UMID", download: true },
                { title: "MÍN.", field: "MIN_UMID", download: true },
              ],
            },
            {
              title: "PTO. ORVALHO (°C)",
              download: true,
              columns: [
                { title: "MÁX.", field: "MAX_PTO", download: true },
                { title: "MÍN.", field: "MIN_PTO", download: true },
              ],
            },
            {
              title: "PRESSÃO (hPa)",
              download: true,
              columns: [
                { title: "MÁX.", field: "MAXHPA", download: true },
                { title: "MÍN.", field: "MINHPA", download: true },
              ],
            },
            {
              title: "VENTO (m/s)",
              download: true,
              columns: [
                { title: "VEL. (méd)", field: "VELVENTO", download: true },
                { title: "DIR. (méd)", field: "DIRVENTO", download: true },
                { title: "RAJ.", field: "RAJ", download: true },
              ],
            },
            {
              title: "RADIAÇÃO",
              download: true,
              columns: [
                {
                  title: this.organizeET0.rad,
                  field: "RADIACAO",
                  download: true,
                },
              ],
            },
            {
              title: "CHUVA",
              download: true,
              columns: [{ title: "mm", field: "CHUVA", download: true }],
            },
            {
              title: "ET0",
              download: true,
              columns: [{ title: "mm", field: "ET0", download: true }],
            },
          ];
        } else if (this.organizeET0.measures == 1) {
          tableColumns = [
            { title: "DATA", field: "DATA", download: true },
            {
              title: "HORA",
              download: true,
              columns: [
                { title: "GMT " + this.utc, field: "GMT", download: true },
              ],
            },
            {
              title: "TEMPERATURA (°C)",
              download: true,
              columns: [{ title: "MÉD.", field: "MED_temp", download: true }],
            },
            {
              title: "UMIDADE (%)",
              download: true,
              columns: [{ title: "MÉD.", field: "MED_umid", download: true }],
            },
            {
              title: "PTO. ORVALHO (°C)",
              download: true,
              columns: [{ title: "MÉD.", field: "MED_pto", download: true }],
            },
            {
              title: "PRESSÃO (hPa)",
              download: true,
              columns: [{ title: "MÉD.", field: "MED_hpa", download: true }],
            },
            {
              title: "VENTO (m/s)",
              download: true,
              columns: [
                { title: "VEL. (méd)", field: "VELVENTO", download: true },
                { title: "DIR. (méd)", field: "DIRVENTO", download: true },
                { title: "RAJ.", field: "RAJ", download: true },
              ],
            },
            {
              title: "RADIAÇÃO",
              download: true,
              columns: [{ title: this.organizeET0.rad, field: "RADIACAO" }],
            },
            {
              title: "CHUVA",
              download: true,
              columns: [{ title: "mm", field: "mm_chuva", download: true }],
            },
            {
              title: "ET0",
              download: true,
              columns: [{ title: "mm", field: "mm_et0", download: true }],
            },
          ];
        }

        for (let d in this.daysToTable) {
          for (let h in this.hours) {
            let dateTime = `${this.daysToTable[d]} ${this.hours[h]}`;
            let afterStart =
              dateTime >= [this.date.START_DATE, this.date.TIME].join(" ");
            let beforeEnd =
              dateTime <=
              moment([this.date.END_DATE, this.date.TIME].join(" ")).format(
                "YYYY-MM-DD HH:mm"
              );
            if (afterStart && beforeEnd) {
              let row = {};
              Object.assign(row, {
                id: index,
                // DATA
                [tableColumns[0].field]: this.daysToTable[d],
                // HORA
                [tableColumns[1].columns[0].field]: this.hours[h],
              });

              /* cinco medições com parâmetros */
              let aux = this.calcData(data, this.daysToTable[d], this.hours[h]);
              let arr = ["temp", "humid", "dew", "pres"];
              // CHECAR SE IRÁ COLOCAR O MÁXIMO OU MÉDIA
              let arr2 =
                this.organizeET0.measures == 2 ? ["max", "min"] : ["med"];
              // SE FOR MAX E MIN
              if (arr2.length == 2) {
                Object.assign(row, {
                  // TEMPERATURA - MAX
                  [tableColumns[2].columns[0].field]: this.formatReportRow(
                    aux[arr[0]][arr2[0]]
                  ),
                  //TEMPERATURA 0 MIN
                  [tableColumns[2].columns[1].field]: this.formatReportRow(
                    aux[arr[0]][arr2[1]]
                  ),
                  //HUMIDADE - MAX
                  [tableColumns[3].columns[0].field]: this.formatReportRow(
                    aux[arr[1]][arr2[0]]
                  ),
                  //HUMIDADE - MIN
                  [tableColumns[3].columns[1].field]: this.formatReportRow(
                    aux[arr[1]][arr2[1]]
                  ),
                  //DEW - MAX
                  [tableColumns[4].columns[0].field]: this.formatReportRow(
                    aux[arr[2]][arr2[0]]
                  ),
                  //DEW - MIN
                  [tableColumns[4].columns[1].field]: this.formatReportRow(
                    aux[arr[2]][arr2[1]]
                  ),
                  //PRESSÃO - MAX
                  [tableColumns[5].columns[0].field]: this.formatReportRow(
                    aux[arr[3]][arr2[0]]
                  ),
                  //PRESSÃO - MIN
                  [tableColumns[5].columns[1].field]: this.formatReportRow(
                    aux[arr[3]][arr2[1]]
                  ),
                });
              }
              // SE FOR MÉDIA
              else {
                Object.assign(row, {
                  // TEMPERATURA - MÉDIA
                  [tableColumns[2].columns[0].field]: this.formatReportRow(
                    aux[arr[0]][arr2[0]]
                  ),
                  //HUMIDADE - MÉDIA
                  [tableColumns[3].columns[0].field]: this.formatReportRow(
                    aux[arr[1]][arr2[0]]
                  ),
                  //DEW - MÉDIA
                  [tableColumns[4].columns[0].field]: this.formatReportRow(
                    aux[arr[2]][arr2[0]]
                  ),
                  //PRESSÃO - MÉDIA
                  [tableColumns[5].columns[0].field]: this.formatReportRow(
                    aux[arr[3]][arr2[0]]
                  ),
                });
              }

              // VENTO
              let wind = ["vel", "dir", "raj"];
              for (let k = 0; k < 3; k++) {
                Object.assign(row, {
                  // velocidade
                  [tableColumns[6].columns[0].field]: this.formatReportRow(
                    aux["wind"][wind[0]]
                  ),
                  //Direção
                  [tableColumns[6].columns[1].field]:
                    aux["wind"][wind[1]] || "-",
                  //Raj
                  [tableColumns[6].columns[2].field]: this.formatReportRow(
                    aux["wind"][wind[2]]
                  ),
                });
              }
              const rad = this.calcRad(
                data["RADIAÇÃOSOLAR"],
                this.daysToTable[d],
                this.hours[h]
              );
              /* RADIAÇÃO */
              Object.assign(row, {
                [tableColumns[7].columns[0].field]: this.formatReportRow(rad),
              });

              // PLUVIOMETRIA
              this.calcPluv(data, this.daysToTable[d], this.hours[h]).then(
                (ret) => {
                  Object.assign(row, {
                    [tableColumns[8].columns[0].field]:
                      this.formatReportRow(ret),
                  });
                }
              );

              this.calcET0(
                this.daysToTable[d],
                this.hours[h],
                aux["temp"]["max"],
                aux["temp"]["min"],
                aux["humid"]["max"],
                aux["humid"]["min"],
                aux["wind"]["vel"],
                this.calcRad(
                  data["RADIAÇÃOSOLAR"],
                  this.daysToTable[d],
                  this.hours[h],
                  "kJ/m²"
                ),
                data["PRESSÃOATMOSFÉRICA"]
              ).then((ret) =>
                Object.assign(row, {
                  [tableColumns[9].columns[0].field]: this.formatReportRow(ret),
                })
              );
              body.push(row);
            }
            index++;
          }
        }
        resolve([body, tableColumns]);
      });
    },
    // NOTE: Qual o sentido desse cálculo?
    organizeDataRainfall(data) {
      let lastOccurrence = data[data.length - 1].VALUE;
      data.map((item) => {
        let diff = item.VALUE - lastOccurrence;
        item.VALUE = Number(diff.toFixed(3));
      });
    },
    searchDataToET0(type) {
      wait.show();
      this.daysToTable = this.makeDaysArray(
        this.date.START_DATE,
        this.date.END_DATE
      );
      this.daysToOrganize = this.daysToTable.map((e) => e);
      this.daysToOrganize.push(
        moment(this.date.END_DATE).add(1, "days").format("YYYY-MM-DD")
      );
      let data = this.date;
      data.NAME = this.sensorsDetails[0].NAME;
      // data.ADDR = this.station.ADDR;
      stations
        .exportData(data)
        .then((response) => {
          if (response[0].length) {
            const itemsWithFormatedDates = response[0].map((data) => {
              data.TIME = moment(data.TIME).format("YYYY-MM-DD HH:mm");
              if (!this.measuresPositions.includes(data.POS)) {
                this.measuresPositions.push(data.POS);
              }
              return data;
            });

            return this.filterMeasurePerPosition(itemsWithFormatedDates);
          } else {
            alert(
              "Não há dados disponíveis para o período ou para os sensores.",
              "e"
            );
            setTimeout(wait.hide(), 2000);
            throw "Não há dados disponíveis para o período ou para os sensores.";
          }
        })
        .then((ret) => {
          return this.filterPerMeasureType(ret, true);
        })
        .then((ret) => this.filterPerDate(ret))
        .then((ret) => this.filterPerHour(ret))
        .then((ret) => {
          if (type === "xlsx") {
            this.organizeTabulator(ret).then((data) => {
              this.createTabulator = true;
              this.typeTable = "xlsx";
              this.tableData = data[0];
              this.tableColumns = data[1];
              return;
            });
            return;
          } else if (type === "csv") {
            this.organizeTabulatorCSV(ret).then((data) => {
              this.createTabulator = true;
              this.typeTable = "csv";
              this.tableData = data[0];
              this.tableColumns = data[1];
              return;
            });
            return;
          } else {
            return this.makeET0TablePdf(ret);
          }
        })
        .then((ret) => {
          if (ret) {
            this.createPDF(ret, "ET0");
          } else {
            return;
          }
        })
        .catch((err) => {
          setTimeout(wait.hide(), 2000);
          console.error(err);
        })
        .finally(() => wait.hide());
    },
    searchPureData(type) {
      wait.show();
      // this.showWaitDialog();
      this.daysToTable = this.makeDaysArray(
        this.date.START_DATE,
        this.date.END_DATE
      );
      let data = this.date;
      // data.ADDR = this.station.ADDR;
      data.NAME = this.sensorsDetails[0].NAME;
      stations
        .exportData(data)
        .then((response) => {
          // if (ret.status) {
          if (response[0].length) {
            this._manipulatedDate = response[0].map((item) => {
              item.TIME = moment(item.TIME).format("YYYY-MM-DD HH:mm");
              if (!this.measuresPositions.includes(item.POS)) {
                this.measuresPositions.push(item.POS);
              }
              return item;
            });
            return this.filterMeasurePerPosition(this._manipulatedDate);
          } else {
            alert(
              "Não há dados disponíveis para o período ou para os sensores.",
              "e"
            );
            setTimeout(wait.hide(), 2000);
            throw "Não há dados disponíveis para o período ou para os sensores.";
          }
          // } else {
          //   alert(ret.log, ret.alert);
          //   setTimeout(wait.hide(), 2000);
          //   throw ret.log;
          // }
        })
        .then((ret) => {
          console.log("Organizando dados...");
          return this.filterPerMeasureType(ret);
        })
        .then((ret) => {
          //Calcular a diferença de valres quando for altura pluviométrica, exibindo só
          // a variação com base no primeiro valor registrado
          // let keys = Object.keys(ret);
          // for (let key of keys) {
          //   if (ret[key].TYPE === "ALTURA PLUVIOMÉTRICA") {
          //     let obj = ret[key]["ALTURAPLUVIOMÉTRICA"];
          //     this.organizeDataRainfall(obj);
          //   }
          // }

          if (["xlsx", "csv", "html"].includes(type)) {
            this.formatPureDataToTabulatorFormat(ret, type);
          } else {
            console.log(`Criando PDF`);
            const pdfData = this.organizeDataToPDF(ret);
            if (pdfData) {
              this.createPDF(pdfData, "BRUTO");
            }
          }
        })
        // .then((ret) => {
        //   if (ret) {
        //     return this.createPDF(ret, "BRUTO");
        //   } else {
        //     return;
        //   }
        // })
        .catch((err) => {
          console.error(
            `Erro na construção do relatório de dados brutos no formato ${type}`,
            err
          );
          setTimeout(wait.hide(), 2000);
          alert(
            `Erro na construção do relatório de dados brutos no formato ${type}`,
            "w"
          );
        })
        .finally(() => wait.hide());
    },
  },
};
</script>

<style scoped>
.container-card {
  transition: all 0.4s;
  padding: 10px;

  border-radius: 4px;
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
  transition: all 0.4s ease;
}
.container-card button {
  font-size: 0.8em;
}
.group-info .title {
  font-weight: 600;
}
.title-card {
  font-size: 1.3em;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  max-height: 28px;
}
.title-card span {
  padding-top: 4px;
  margin-left: 4px;
}
.container-card .config-details {
  font-size: 0.87em;
  color: var(--text-gray-primary);
}
.bg-logo-monit {
  position: fixed;
  width: 100%;
  height: 80vh;
  z-index: -3;
  margin-left: -55px;
}
.monitCard.station {
  padding-top: 17px;
  max-height: 60px;
  text-align: center;
}
.monitCard.sensor-station {
  height: 80px;
}
.detail {
  max-height: 69vh;
}

@media screen and (max-width: 767px) {
  .monit-page {
    padding-top: 32px;
  }
  .monit-page .monit-main {
    width: 100% !important;
    transition: 0.1s;
    overflow-y: auto;
    height: 100%;
  }
}
@media screen and (max-width: 280px) {
  .title-card {
    font-size: 1.1em;
  }
}
.detail-measure {
  border-color: transparent;
  padding: 12px;
}
.station-monit .disabled-link {
  cursor: default;
  pointer-events: none;
}
.station-monit .disabled-link .monitCard {
  opacity: 0.6;
}
.detail .measures h5 {
  margin-bottom: 0;
}
.margin-bottom {
  margin-bottom: 10px;
}
</style>
